import Vue from 'vue'
import App from './App.vue'
import router from './router'
/**
 * Axios请求头的封装和Api接口
 */
import * as Request from './utils/Request'
import { Api } from './utils/Api'
/**
 * 引用ElementUI 和 ElementUI的样式覆盖
 */
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
/**
 * 自定义样式和自定义方法
 */
import 'normalize.css'
import './assets/styles/common.scss'

Vue.config.productionTip = false

Vue.use(ElementUI);

Vue.prototype.$request = Request;
Vue.prototype.$api = Api;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
